// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1Bv2p","subheader":"ReorderModal_subheader__1a466","listWrap":"ReorderModal_listWrap__1foKM"};